<template>
  <Card :name="config.variableFullName" >
    <template v-slot:header>
      <h4 class="card-title">
        {{ config.variableFullName }}
      </h4>
    </template>

    <i
      class="fa"
      :class="[config.icon, getIconColorClass()]"
      style="font-size: 30px"
    ></i>
  </Card>
</template>

<script>
import emitter from "@/eventBus";
export default {
  props: ["config"],
  data() {
    return {
      value: false,
      topic: "",
      props: ["config"],
    };
  },
  watch: {
    config: {
      immediate: true,
      deep: true,
      handler() {
        setTimeout(() => {
          this.value = false;

          emitter.off(this.topic + "/sdata");

          let variable = this.config.variable;
          if (this.$store.state.selectedDevice.ext_mqtt) {
            variable = this.config.variableFullName;
          }

          //userId/dId/uniquestr/sdata
          this.topic =
            this.config.userId +
            "/" +
            this.config.selectedDevice.dId +
            "/" +
            variable;

          emitter.on(this.topic + "/sdata", this.processReceivedData);
        }, 300);
      },
    },
  },
  mounted() {},
  beforeDestroy() {
    emitter.off(this.topic + "/sdata");
  },
  methods: {
    processReceivedData(data) {
      try {
        this.value = data.value;
      } catch (error) {
        console.log(error);
      }
    },

    getIconColorClass() {
      if (!this.value) {
        return "text-dark";
      }

      if (this.config.class == "success") {
        return "text-success";
      }
      if (this.config.class == "primary") {
        return "text-primary";
      }
      if (this.config.class == "warning") {
        return "text-warning";
      }
      if (this.config.class == "danger") {
        return "text-danger";
      }
    },
  },
};
</script>
